import { z } from 'zod';
import { CaseIdSchema, IsoTimestampSchema, PeriodIdSchema, UserIdSchema } from './common.js';

export const PeriodFieldsSchema = z.object({
  id: PeriodIdSchema,
  caseId: CaseIdSchema,
  label: z.string().min(1).max(120),
  description: z.string().max(4000).optional(),
  from: IsoTimestampSchema,
  to: IsoTimestampSchema,
  color: z.string().regex(/^#[0-9a-fA-F]{6}$/, 'Farge må være hex (#RRGGBB)'),
  createdBy: UserIdSchema,
  createdAt: IsoTimestampSchema,
});

export const PeriodSchema = PeriodFieldsSchema.refine((p) => p.from <= p.to, {
  message: 'Sluttidspunkt må være etter eller lik starttidspunkt',
  path: ['to'],
});

export type Period = z.infer<typeof PeriodSchema>;
